<template>
  <div class="down-part">
    <el-form
      ref="ruleForm"
      :inline="true"
      :model="ruleForm"
      status-icon
      label-width="104px"
      label-position="left"
    >
      <div>
        <el-form-item label="事件编号：" prop="">
          <el-input
            v-model="ruleForm.number2"
            size="medium"
          />
        </el-form-item>
        <el-form-item label="急救车：" prop="carName">
          <el-select
            v-model="ruleForm.carName"
            class="rule-form-car-name"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in carOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="时间：" prop="start">
          <el-date-picker
            v-model="ruleForm.start"
            class="ruleFormCarStart"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择日期"
          />
          <el-form-item class="time-across" label="至" prop="end" label-width="40px"/>
          <el-date-picker
            v-model="ruleForm.end"
            type="date"
            value-format="YYYY-MM-DD"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="急救地址：" prop="addr">
          <el-input
            v-model="ruleForm.addr"
            size="medium"
            class="rule-form-car-addr"
          />
        </el-form-item>
      </div>
      <div>
        <el-form-item label="患者姓名：" prop="medicalhistoryName">
          <el-input
            v-model="ruleForm.medicalhistoryName"
            class="rule-form-patient-name"
          />
        </el-form-item>
        <el-form-item label="性别：" prop="gender">
          <el-select
            v-model="ruleForm.gender"
            class="rule-form-patient-gender"
            clearable
            placeholder="请选择性别"
          >
            <el-option
              v-for="item in genderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="主诉：" prop="mainComplaint">
          <el-input
            v-model="ruleForm.mainComplaint"
            class="rule-form-main-complaint"
          />
        </el-form-item>
        <el-form-item>
          <div class="button-group">
            <el-button @click="searchForm('ruleForm')">搜索</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <div class="patient-table">
      <el-table
        :data="patientList"
        height="202"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop=""
          type="index"
          label="序号"
          width="70"
        />
        <el-table-column
          align="center"
          prop="number"
          label="事件编号"
          width="110"
        />
        <el-table-column
          align="center"
          prop="formatTime"
          label="受理时间"
          width="110"
        />
        <el-table-column
          align="center"
          prop="carName"
          label="急救车编号"
          width="130"
        />
        <el-table-column
          align="center"
          prop="turout_time"
          label="发车时间"
          width="110"
        />
        <el-table-column
          align="center"
          prop="done_time"
          label="收车时间"
          width="110"
        />
        <el-table-column
          align="center"
          prop="type"
          label="事件类型"
          width="110"
        />
        <el-table-column
          align="center"
          prop="patientAddr"
          label="地点"
          width="140"
        />
        <el-table-column
          align="center"
          prop="name"
          label="患者姓名"
          width="110"
        />
        <el-table-column align="center" prop="gender" label="性别" width="70"/>
        <el-table-column align="center" prop="mainComplaint" class-name="main-complaint" label="主诉"/>
        <el-table-column align="center" label="操作">
          <template #default="{row}">
            <el-button
              type="text"
              size="medium"
              @click="handleLook(row.id, row.ambulance_type)"
            >
              查看
            </el-button>
            <el-button
              v-show="canEditRow(row)"
              type="text"
              size="medium"
              @click="writeMore(row.id, row.ambulance_type)"
            >
              补写
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        :page-size="ruleForm.pageSize"
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getPatientsInfo } from "@api/hospitalList";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "HistoryForm",
  emits: ["resetForm", "searchForm"],
  data() {
    return {
      total: 0, // 总页数
      carOptions: [], // 急救车选项
      userType: "", // 登陆用户的类型
      dateTime: "", // 当前时间
      patientList: [],
      userID: "",
      ruleForm: {
        pageSize: 5, // 每页数据数量
        number2: "", // 事件编号
        start: "",
        end: "",
        ambulanceName: "",
        carName: "",
        gender: "",
        addr: "",
        medicalhistoryName: "",
        mainComplaint: "",
      },
      genderOptions: [
        {
          value: "男",
          label: "男",
        },
        {
          value: "女",
          label: "女",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      userInfo: "userInfo",
      carObject: "carObject",
    }),

  },
  mounted() {
    ({ loginUserId: this.userType, id: this.userID } = this.userInfo);
    this.getCarList();
    this.getDateTime();
    this.getMissions();
  },
  methods: {
    /**
     * 判断是否显示补写按钮 (护士或者信息科人员不可以填写)
     * 1. 24小时以内!!
     * 2. 管理员都可以补写
     * 3. 安卓那里没有登录下单, 所有医生可以补写
     * 4. 安卓下单的时候登录, 符合的医生才可以补写
     * */
    canEditRow({ done_time, doctorId }) {
      // (优先判断) 是否是24小时以内的, 不是有效期内, 不可以补写
      if (!this.showAddBtn(done_time)) {
        return false;
      }
      // 是管理员, 可以补写
      if (this.userType === 1) {
        return true;
      }
      // 是医生, 并且 安卓那里下单的时候没有登录, 所有人都可以写
      if (this.userType === 2 && !doctorId) {
        return true;
      }
      // 不是以上情况, 只有医生可以补写自己的
      return doctorId === this.userID;
    },
    /**
     * 获取所有的急救(历史)任务表格
     * */
    async getMissions() {
      let code, data, all_counts, msg;
      try {
        ({ code, data, all_counts, msg } = await getPatientsInfo(this.ruleForm));
        if (code !== 200) {
          showWindowMessage(3, msg, this);
          return;
        }
        data.forEach(item => {
          item.carName = this.carObject[item.ambulanceId];
        });
        this.total = all_counts;
        this.patientList = data;
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 点击翻页页码 进行翻页
     * */
    async handleCurrentChange(currentPage) {
      this.ruleForm.page = currentPage;
      await this.getMissions();
    },
    /**
     * 查看事例
     * @param {number} id - 查看的id
     * @param {string} ambulanceType - 查看的类型
     * */
    handleLook(id, ambulanceType) {
      // 查看病例历史记录
      if (ambulanceType === "急救车") {
        this.$router.push({ path: `/showPatient/${id}` });
      } else {
        this.$router.push({ path: `/showPatientSmart/${id}` });
      }
    },
    getDateTime() {
      // 获取当前时间
      const now = new Date();
      const year = now.getFullYear(); // 得到年份
      const month = now.getMonth() + 1; // 得到月份
      const date = now.getDate(); // 得到日期
      const hour = now.getHours(); // 得到小时数
      const minute = now.getMinutes(); // 得到分钟数
      this.dateTime = `${year}-${month}-${date} ${hour}:${minute} `;
    },
    /**
     * 获得弹窗的车辆选择按钮数据
     * */
    getCarList() {
      this.ambulanceLists.forEach((ele) => {
        const carName = ele.name + "(" + ele.idName + ")";
        this.carOptions.push({ value: ele.id, label: carName });
      });
    },
    /**
     * 点击搜索, 开始搜索表单
     * */
    searchForm() {
      // 发送请求到后台查询
      this.ambulanceLists.forEach((ele) => {
        if (ele.id === this.ruleForm.carName) {
          this.ruleForm.ambulanceName = ele.name;
        }
      });
      this.getMissions();
    },

    /**
     * 重置表单
     * */
    resetForm(formName) {
      this.ruleForm.ambulanceName = ""; // 下面的代码无法把这个清空
      this.ruleForm.number2 = ""; // 下面的代码无法把这个清空
      this.$refs[formName].resetFields();
      this.getMissions();
    },

    /*
    * 是否展示编辑按钮 (时间是否是24小时以内)
    * */
    showAddBtn(done_time) {
      const date1 = new Date(this.dateTime).getTime() - new Date(done_time).getTime(); // 时间差的毫秒数
      const passedTime = date1 / 1000 / 60 / 60; // 转换成小时
      if (done_time) {
        return passedTime <= 24;
      } else {
        return false;
      }
    },
    /**
     * 跳转到补写页面
     * @param {number} id - 要补写的id
     * @param {string} ambulanceType - 要补写的类型
     * */
    writeMore(id, ambulanceType) {
      this.$router.push({ path: `/writeMore/${id}/add` });
      if (ambulanceType === "急救车") {
        this.$router.push({ path: `/writeMore/${id}/add` });
      } else {
        this.$router.push({ path: `/writeMoreSmart/${id}/add` });
      }
    },
    /**
     * 跳转到编辑页面
     * @param {number} id - 要编辑的id
     * */
    handleEdit(id) {
      // 跳转到编辑页面,进行重新编辑
      this.$router.push({ path: `/addPatient/${id}` });
    },
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .main-complaint div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
  }
}

.patient-table {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.down-part {
  background: #FFFFFF;
  border-radius: 10px;
  margin-top: 24px;
  padding: 20px 30px;
}

.el-form ::v-deep {
  .el-input__inner {
    height: 32px;
    width: 140px;

    border: 1px solid #999999;
    border-radius: 10px;
  }

  .el-form-item {
    margin-bottom: 16px;
    margin-right: 50px;;
  }

  .el-form-item__label {
    padding: 0;
  }

  .rule-form-main-complaint {
    .el-input__inner {
      width: 320px;
    }
  }

  // 时间选择的"至"字
  .time-across {
    margin: 0;
    padding: 0;

    .el-form-item__label {
      padding: 0;
      text-align: center;
    }
  }

  // 时间选择框
  .el-date-editor.el-input {
    width: 140px;
  }

  .button-group {
    display: flex;
    align-items: center;
    height: 40px;
    width: 266px;
    justify-content: space-evenly;

    .el-button {
      width: 96px;
      height: 32px;
      min-height: 32px;
      border: 1px solid #2AA5E3;
      border-radius: 16px;
      padding-top: 9px;
      color: #2AA5E3;
    }
  }
}
</style>
